/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import * as RN from "react-native";

import { skaleBlack } from "config/UpduoColors";

interface TextInputProps extends RN.TextInputProps {
  style?: RN.TextStyle;
}

export default function TextInput({
  style,
  children,
  ...rest
}: React.PropsWithChildren<TextInputProps>) {
  const defaultFontSize = 14;
  const fontSize = style?.fontSize ? style.fontSize : defaultFontSize;
  const fontFamily = "ObjectSans-Regular";
  return (
    <RN.TextInput
      {...rest}
      style={[
        style,
        {
          fontFamily,
          fontSize,
          color: style?.color ? style.color : skaleBlack,
        },
      ]}
    >
      {children}
    </RN.TextInput>
  );
}
